import store from "@/store"
import _ from "lodash"

export default {
  created() {
    this.debouncedResizeHandler = _.debounce(() => this.resizeHandler(), 100, {
      leading: true,
      trailing: true
    })
  },
  beforeMount() {
    window.addEventListener("resize", this.debouncedResizeHandler)
  },
  mounted() {
    this.debouncedResizeHandler()
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.debouncedResizeHandler)
  },
  methods: {
    resizeHandler() {
      let tableHeight = document.querySelector(".main-wrap")?.clientHeight - 56 - 42 - 8
      store.commit("backend/SET_TABLE_HEIGHT", tableHeight)
    }
  }
}
